import React, { useState } from "react";
import Navigation from "../components/Navigation";
import Footer from "../components/Footer";
import { mockData } from "../utils/mockData";
import { ChevronDown, ChevronRight } from "lucide-react";
import { Card } from "../components/ui/card";

const FAQPage = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="min-h-screen page-enter">
      {/* Hero Section with Ski Lift Image */}
      <div className="relative min-h-screen flex flex-col justify-center items-center text-center px-6">
        {/* Background Image */}
        <div className="absolute inset-0 z-0 scale-in">
          <img 
            src="https://customer-assets.emergentagent.com/job_40f6e18e-0673-4fc0-a3ca-3292e6af1a13/artifacts/z7vscjyg_Ski%20Lift.jpg"
            alt="Ski lift with mountain views"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/40"></div>
        </div>

        {/* Navigation */}
        <div className="absolute top-0 left-0 right-0 z-20 slide-in-top">
          <Navigation />
        </div>

        {/* Hero Content */}
        <div className="relative z-10 max-w-4xl">
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight drop-shadow-2xl slide-in-bottom">
            Frequently Asked Questions
          </h1>
          <p className="text-xl md:text-2xl text-white mb-8 max-w-3xl mx-auto leading-relaxed drop-shadow-xl stagger-1">
            Got questions? We've got answers! Find everything you need to know about our trips and community.
          </p>
        </div>
      </div>

      {/* FAQ Section */}
      <section className="py-20 px-6 bg-white slide-in-bottom stagger-2">
        <div className="max-w-4xl mx-auto">
          <div className="space-y-4">
            {mockData.faqs.map((faq, index) => (
              <Card key={index} className="border-blue-100/50 bg-white/90 backdrop-blur-sm shadow-lg overflow-hidden hover-lift relative z-10">
                <div>
                  <button
                    onClick={() => toggleAccordion(index)}
                    className="w-full p-6 text-left flex items-center justify-between transition-all duration-300"
                    style={{
                      backgroundColor: openIndex === index ? 'rgba(29, 71, 106, 0.05)' : 'transparent'
                    }}
                    onMouseEnter={(e) => {
                      if (openIndex !== index) e.target.style.backgroundColor = 'rgba(29, 71, 106, 0.05)';
                    }}
                    onMouseLeave={(e) => {
                      if (openIndex !== index) e.target.style.backgroundColor = 'transparent';
                    }}
                  >
                    <h3 className="text-lg font-semibold text-slate-800 pr-4">{faq.question}</h3>
                    {openIndex === index ? (
                      <ChevronDown className="w-5 h-5 flex-shrink-0 transform transition-transform duration-300" style={{color: '#1d476a'}} />
                    ) : (
                      <ChevronRight className="w-5 h-5 flex-shrink-0 transform transition-transform duration-300" style={{color: '#1d476a'}} />
                    )}
                  </button>
                  {openIndex === index && (
                    <div className="px-6 pb-6 border-t border-blue-100/50" style={{backgroundColor: 'rgba(29, 71, 106, 0.03)'}}>
                      <p className="text-slate-700 leading-relaxed pt-4">{faq.answer}</p>
                    </div>
                  )}
                </div>
              </Card>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default FAQPage;